/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import { Form } from 'redux-form';
import { Button, Col, Row } from 'reactstrap';
import InputText from 'views/ui/fields/text';
import { emailsWithEmptyValidator } from 'utils/validators';

const EmailsForm = ({ handleSubmit, invalid, pristine, submitting }) => {
  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Row className="mb-4 d-flex justify-content-center">
        <Col xs={12} xl={6} lg={6} md={6} sm={12}>
          <label className="grey2__text mt-1 nowrap">Key Metrics Reports</label>
          <InputText
            name="keyMetrics"
            className="form-control"
            placeholder="Key Metrics Reports"
            validate={[emailsWithEmptyValidator()]}
          />
        </Col>
        <Col xs={12} xl={6} lg={6} md={6} sm={12}>
          <label className="grey2__text mt-1 nowrap">
            Consolidated Key Metrics Reports
          </label>
          <InputText
            name="consolidatedKeyMetrics"
            className="form-control"
            placeholder="Consolidated Key Metrics Reports"
            validate={[emailsWithEmptyValidator()]}
          />
        </Col>
      </Row>
      <Row className="mt-5 d-flex justify-content-center">
        <Button
          type="submit"
          className="location__save"
          disabled={invalid || pristine || submitting}
        >
          Save settings
        </Button>
      </Row>
    </Form>
  );
};

export default EmailsForm;
